import { render, staticRenderFns } from "./AdminDeviceGroup.vue?vue&type=template&id=5b2ed65c&"
import script from "./AdminDeviceGroup.vue?vue&type=script&lang=js&"
export * from "./AdminDeviceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports